export const APP_BOARD_STATE_KEY = Symbol('appBoardStateKey')
